export const BENEFTIS = [
    {
        id: 1,
        title: "Carné oficial",
        description: "Carnet oficial físico y digital como socio Community Member.",
        icon: "🪪"
    },
    {
        id: 2,
        title: "Certificados",
        description: "Derecho a ser certificado en los cursos educativos y de capacitación Asoblockchain.",
        icon: "👩‍🎓"
    },
    {
        id: 3,
        title: "Eventos VIP",
        description: "Participación en eventos VIP, de negocios y networking.",
        icon: "🎪"
    },
    {
        id: 4,
        title: "Token",
        description: "Participación en la pre-venta oficial del Token de la asociación.",
        icon: "💰"
    },
    {
        id: 5,
        title: "Coworking",
        description: "Derecho al uso de 1 hora al mes en los espacios de Coworking/Networking de la Asociación.",
        icon: "👨‍💻"
    },
    {
        id: 6,
        title: "NFT propio",
        description: "Derecho a la creación de su propio NFT, expuesto en la galería de Asociación.",
        icon: "🖼"
    },
    {
        id: 7,
        title: "Insignia de fan",
        description: "Insignia de fan destacado de la Asociación.",
        icon: "🎗"
    },
]